import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { GlobalState } from "../GlobalState";
import css from './RightSidebar.m.scss'
import { EnumIconNames } from "../enums/EnumIconNames";
import { GlobalRightSidebar } from "../GlobalRightSidebar";
import { BasketSmall } from "./BasketSmall";

const filename = 'RightSidebar'

interface Attrs{

}

export class RightSidebar extends DomeComponent<Attrs>{
    //sidebarWidth:number = 0
    refBackdrop!:HTMLDivElement
    refSidebar!:HTMLDivElement
    refMenuContainer!:HTMLDivElement
    refContainer!:HTMLDivElement
    render(){
        return (
            <>
            <div class={css.sidebar} ref={ref => this.refSidebar = ref}>
                {/* <a href="javascript:void(0)" class={css.buttonClose} onclick={() => GlobalState.onSidebarEvent.triggerAsync(false)}>&times;</a> */}
                <div ref={ref => this.refMenuContainer = ref} class={css.menuItems}>
                    <div class={css.buttonClose} onClick={() => GlobalRightSidebar.eventOnHide.triggerAsync()}>
                        <span class={EnumIconNames.Cancel} />
                    </div>
                    <div ref={ref => this.refContainer = ref}>
                        <BasketSmall />
                    </div>
                    
                </div>
            </div>            
            <div class={css.backdrop} ref={ref => this.refBackdrop = ref} onClick={() => GlobalRightSidebar.eventOnHide.triggerAsync()}></div>
            </>
        )
    }

    

    async afterRender(){
        GlobalRightSidebar.eventOnHide.subscribe(() => {
            //console.log(filename, 'eventOnHide')
            //this.sidebar.style.opacity = '0.5'
            // this.refSidebar.style.transitionDuration = Settings.sidebarTransitionDuration
            // this.refSidebar.style.width = '0'
            this.hide()
        })

        GlobalRightSidebar.eventOnShow.subscribe(() => {
            //console.log(filename, 'eventOnShow')
            //this.sidebar.style.opacity = '1'
            // this.refSidebar.style.transitionDuration = Settings.sidebarTransitionDuration
            // this.refSidebar.style.width = Settings.sidebarWidth+'px'
            this.show()
        })

        //this.populateMenuAsync()

        GlobalState.eventPageChange.subscribe(async () => {
            await GlobalRightSidebar.hideAsync()
        })
        
    }

    protected show(){
        this.refSidebar.classList.add(css.sidebarOpen)
        this.refBackdrop.classList.add(css.backdropVisible)
    }

    protected hide(){
        this.refSidebar.classList.remove(css.sidebarOpen)
        this.refBackdrop.classList.remove(css.backdropVisible)
    }

    // async populateMenuAsync() {
    //     try {
    //         const topLevelItems = await ServerMenu.getTopLevelItemsSortedAsync()
    //         if (!topLevelItems) throw new Error('unable to get topLevelItems')
    //         console.log('topLevelItems=', topLevelItems)
    //         DomeManipulator.replaceAllChildrenAsync(this.refContainer,
    //             <nav role="navigation">
    //                 {topLevelItems.map((item) => <MenuItem jsonMenuItem={item} />)}
    //             </nav>)

    //     } catch (x) {
    //         console.error('query `topmenuitems` failed', x)
    //     }

    // }

}